// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SMAConnector from './components/Connector';
import SMACallback from './components/CallBack';
import ServiceTerms from './components/ServiceTerms';
import DataPrivacy from './components/DataPrivacy';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SMAConnector />} />
        <Route path="/sma-callback" element={<SMACallback />} />
        <Route path="/service-terms" element={<ServiceTerms />} />
        <Route path="/data-privacy" element={<DataPrivacy />} />
      </Routes>
    </Router>
  );
}

export default App;